import { PageHeader } from '@/components/layout/PageHeader';
import { SocialCommentsWorkspace } from '../components/SocialCommentsWorkspace';

export function SocialCommentsHubPage() {
  return (
    <div>
      <PageHeader
        title="Comments Center"
        description="Reply, assign, resolve, and convert Facebook, Instagram, LinkedIn, X, and YouTube comments to CRM leads"
        breadcrumbs={[{ label: 'Social', to: '/social' }, { label: 'Comments' }]}
      />
      <SocialCommentsWorkspace />
    </div>
  );
}
